import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=7c26b0fb&scoped=true&lang=pug&"
import script from "./Heading.vue?vue&type=script&lang=js&"
export * from "./Heading.vue?vue&type=script&lang=js&"
import style0 from "./Heading.vue?vue&type=style&index=0&id=7c26b0fb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c26b0fb",
  null
  
)

export default component.exports